export default () => {
  return {
    'lowResolution': '',
    'standardResolution': ''
  }
}
